export enum IndicatorType {
  NUMBER_OF_CLOSED_CHATS = 0,
  CONVERSION_AMOUNT = 1,
  CONVERSION_COUNT = 2,
  SURVEY_NPS = 3,
  SURVEY_KNOWLEDGE = 4,
  SURVEY_PROFESSIONALISM = 5,
  SURVEY_JUST_OVERALL = 6,
  SURVEY_RESPONSIVENESS = 7
}

export enum IndicatorDuration {
  TODAY = 0,
  THIS_WEEK = 1
}

export enum CompareToDuration {
  YESTERDAY = 1,
  LAST_WEEK = 2,
  LAST_30_DAYS = 3
}

export enum AgentStatStates {
  MINIMIZED = 'minimized',
  EXPANDED = 'expanded'
}

export enum CompareToType {
  NONE = 0,
  SELF = 1,
  DEPARTMENT = 2,
  TARGET_VALUE = 3
}
